export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "cb14e8576fmshe128071c215bd93p10d387jsn1b17baefe40b",
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};

export const WEATHER_API_KEY = "55ba4d591a2f4eeef69609d4c084c9be";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";

export const GEO_API_URL = " https://wft-geo-db.p.rapidapi.com/v1/geo";
